/**
 * Created by andrey on 15.11.2024
 */

const VKLogic = function () {
    PlatformLogic.call(this);
};

VKLogic.prototype = Object.create(PlatformLogic.prototype);
VKLogic.prototype.constructor = VKLogic;

VKLogic.prototype.logPushes = function () {
    const params = connector.utils.getRequestParameters();

    const pushId = params.ref_notification_id;
    const push = pushId && Object.values(PUSHES).find((push) => String(push.id) === String(pushId));
    const pushCode = push && push.code || pushId;
    
    if (pushCode) {
        this.logClickEvent(pushCode);
    }
};